var Arrow = function(config) {
    config = config || {};

    this.detector = config.detector;
    this.createPreviewStreamUrl = config.createPreviewStreamUrl;
    this.logger = config.logger;
    this.logger.debug(this, 'Initialized Arrow');

    this.email = config.email;
    this.i18n = config.i18n;

    this.buttons = {};
    this.intervals = {};

    var self = this;

    this._registerEvents();
};

Arrow.prototype._registerEvents = function() {
    var $buttons = $('.detection-button');
    var _this = this;

    // handle detection button click
    $buttons.click(function() {
        return _this.detectStream(this);
    });

    // handle "enter" event in user credentials forms
    $('input', $buttons.closest('.stream-info')).keypress(function(e) {
        var $wrapper = $(e.target).closest('.stream-info');
        var $button = $('.detection-button', $wrapper);
        if (e.keyCode === 13) {
            return _this.detectStream($button);
        }
    });

    // handle network scan button click
    $('.scan-button').on('click', function() {
        $('#waiting').foundation('open');

        _this.scanNetwork();

        setInterval(function() {
            _this.pollDeviceStatus();
        }, 5000);

        return false;
    });

    $('.custom-stream-link').on('click', function(e) {
        var $wrapper = $(e.target).closest('li');
        var $streamInfo = $('.stream-info', $wrapper);

        _this.initCustomStreamModal($streamInfo);

        $('#custom-stream').foundation('open');

        return false;
    });

    // set focus to the camera name field when a camera is selected
    $('.controls input[type=checkbox]').click(function() {
        var $checkbox = $(this);
        if ($checkbox.prop('checked')) {
            $('input[type=text]', $checkbox.closest('.controls')).focus();
        }
    });

    // Destroy player when closing custom stream modal
    var $customStreamModal = $('#custom-stream');
    $customStreamModal.on('closed.zf.reveal', function() {
        var ele = document.getElementById('player_custom_stream');
        if (ele.data && 'player' in ele.data && ele.data.player) {
            ele.data.player.destroy();
        }
    });
}

Arrow.prototype.getCredentialsRequired = function(customStream) {
    return !customStream || $('#custom-stream-credentials-toggle').prop('checked');
};

Arrow.prototype.getDetectorConfig = function($streamInfo, customStream) {
    var baseUrl = $streamInfo.data("streamBaseUrl");
    var path = $streamInfo.data("streamPath");

    // the stream path in the custom stream modal is in a hidden input
    // instead of the data attribute
    if (path === undefined || path === null) {
        path = $('[name="stream_path"]', $streamInfo).val();
    }

    if (path.length == 0) {
        path = '/';
    } else if (path.substring(0, 1) != '/') {
        path = '/' + path;
    }

    var config = {
        address: baseUrl.substring(0, baseUrl.length - 1) + path,
        brand: $streamInfo.data("manufacturer"),
        httpProxy: $streamInfo.data("proxy"),
        others: {
            key: $streamInfo.data("key"),
            email: this.email,
            userAgent: navigator.userAgent,
        }
    };

    if (this.getCredentialsRequired(customStream)) {
        config.username = $('[name="username"]', $streamInfo).val();
        config.password = $('[name="password"]', $streamInfo).val();
    }

    if (customStream) {
        config.detectionMode = 'single';
        config.others.key = 'custom_stream';
    }

    return config;
};

Arrow.prototype.enableDetectionControls = function(key, enable) {
    var $button = this.buttons[key];
    var $text = $('span', $button);
    var $wrapper = $button.closest('.stream-info');
    var $inputs = $('input', $wrapper);

    $inputs.prop('disabled', !enable);

    if (enable) {
        $button.removeClass('disabled');
        $text.text(this.i18n.detectButton);
        clearInterval(this.intervals[key]);
    } else {
        $button.addClass('disabled');
        $text.text(this.i18n.detectionInProgress);
        this.intervals[key] = setInterval(function() {
            $text.fadeOut(500);
            $text.fadeIn(500);
        }, 1000);
    }
};

Arrow.prototype.detectStream = function(element) {
    var $button = $(element);
    var $streamInfo = $button.closest('.stream-info');

    var customStream = $button.hasClass('custom-stream');

    if ($button.hasClass('disabled')) {
        return false; // prevent fast users
    }

    var config = this.getDetectorConfig($streamInfo, customStream);

    if (this.getCredentialsRequired(customStream) && !config.username) {
        // TODO: we should probably show a pop-up instead of this ugly alert
        window.alert(this.i18n.enterCredentials);
        $('[name="username"]', $streamInfo).focus();
        return false;
    }

    this.buttons[config.others.key] = $button;

    this.enableDetectionControls(config.others.key, false);

    var socket = new WebSocket(this.detector);

    var self = this;

    socket.onmessage = function(event) {
        try {
            self.handleWSMessage(event);
        } catch (ex) {
            self.logger.error("Unable to handle a WebSocket message", ex);
        }

        socket.close();
    };

    socket.onopen = function(event) {
        socket.send(JSON.stringify({
            type: 'detection',
            data: config
        }));
    };

    return false;
};

Arrow.prototype.handleWSMessage = function(event) {
    try {
        var message = JSON.parse(event.data);
    } catch (ex) {
        this.logger.info("Received invalid WebSocket message", event);
    }

    if (message.type === 'detection:succeeded') {
        this.handleDetectorResponse(message.data);
    }
};

Arrow.prototype.handleDetectorResponse = function(response) {
    var data = response.data || {};
    var others = response.others || {};
    var key = others.key;
    var possibleBrands = data.possibleBrands || [];
    var streams = data.streams || [];
    var h264Streams = streams.filter((s) => s.type === 'h264');
    var h265Streams = streams.filter((s) => s.type === 'h265');
    var mjpegStreams = streams.filter((s) => s.type === 'mjpeg');

    var $button = this.buttons[key];

    if (!$button) {
        return;
    }

    var $streamInfo = $button.closest('.stream-info');

    this.enableDetectionControls(key, true);

    // treat this as an error
    if (response.status === 'ok' && !h264Streams.length && !h265Streams.length && !mjpegStreams.length) {
        response.status = 'error';

        if (streams.length) {
            response.error = 'UNEXPECTED_CONTENT';
        } else {
            response.error = 'STREAM_NOT_FOUND';
        }
    }

    if (response.status === 'ok') {
        this.logger.debug(this, 'Detector detected stream', response);

        var brand = possibleBrands.length ? possibleBrands[0] : null;
        var url;
        var detectedCameraType;

        if (h264Streams.length) {
            url = h264Streams[0].url;
            detectedCameraType = 'h264';
        } else if (h265Streams.length) {
            url = h265Streams[0].url;
            detectedCameraType = 'h265';
        } else if (mjpegStreams.length) {
            url = mjpegStreams[0].url;
            detectedCameraType = 'mjpeg';
        }

        var width = 540;
        var height = 405;
        var autoplay = true;

        if (key == 'custom_stream') {
            $('.add-button', $button.closest('.stream-info')).removeClass('hide');
            $('[name="camera_type"]', $button.closest('.stream-info')).val(detectedCameraType);

            this.createPlayer({
                key: key,
                url: url,
                height,
                width,
                autoplay,
                cameraType: detectedCameraType,
                continentCode: $streamInfo.data("continentCode")
            });
        } else {
            width = 400;
            height = 373;

            var _this = this;

            // createPreviewStream (via createPlayer) must not fire concurrently with setCredentials:
            // both requests read the session, and other middleware re-saves the whole session blob on
            // every request, so a slower createPreviewStream finishing after setCredentials would
            // silently overwrite the just-saved credentials with its own stale, pre-setCredentials copy.
            this.setCredentials(key, url, brand, detectedCameraType, function() {
                $('[type=checkbox]', $button.closest('li')).removeAttr('disabled');
                $('.pairing-button', $button.closest('li')).removeClass('disabled');
                $('.stream-select-button', $button.closest('li')).removeAttr('disabled');

                _this.createPlayer({
                    key: key,
                    url: url,
                    height: height,
                    width: width,
                    autoplay: autoplay,
                    cameraType: detectedCameraType,
                    continentCode: $streamInfo.data("continentCode")
                });
            });
        }
    } else {
        $('[name="username"]', $streamInfo).focus();
        // TODO: we should probably show a pop-up instead of this ugly alert
        window.alert(this.i18n.errors[response.error] || this.i18n.detectionFailed);
        this.logger.debug(this, 'Detector resulted to error', response);
    }
};

Arrow.prototype.initCustomStreamModal = function($streamInfo) {
    var $modal = $('#custom-stream');
    var $dstStreamInfo = $('.stream-info', $modal);

    var key = $streamInfo.data('key');

    this.copyDataValue($dstStreamInfo, $streamInfo, 'key');
    this.copyDataValue($dstStreamInfo, $streamInfo, 'manufacturer');
    this.copyDataValue($dstStreamInfo, $streamInfo, 'proxy');
    this.copyDataValue($dstStreamInfo, $streamInfo, 'streamBaseUrl');
    this.copyDataValue($dstStreamInfo, $streamInfo, 'type');
    this.copyDataValue($dstStreamInfo, $streamInfo, 'protocol');
    this.copyDataValue($dstStreamInfo, $streamInfo, 'continentCode');

    $('[name="key"]', $modal).val(key);
    $('[name="username"]', $modal).val('');
    $('[name="password"]', $modal).val('');
    $('[name="stream_path"]', $modal).val('');

    $('#custom-stream-credentials-toggle').prop('checked', false);

    $('.credentials', $modal).addClass('hide');
    $('.add-button', $modal).addClass('hide');

    var localBaseUrl = $streamInfo.data('localBaseUrl');
    var macAddress = $streamInfo.data('macAddress');

    $('.modal-heading', $modal).html(this.i18n.pathPrompt.replace('%mac%', macAddress));
    $('.base-url', $modal).html(localBaseUrl.substring(0, localBaseUrl.length - 1));
};

Arrow.prototype.copyDataValue = function($dst, $src, name) {
    $dst.data(name, $src.data(name));
};

Arrow.prototype.createPlayer = function(config) {
    this.createPreviewStream(config, function(data) {
        $('#player_' + config.key).empty();
        new Angelcam.Player({
            parentId: '#player_' + config.key,
            source: data.url,
            width: config.width,
            height: config.height,
            autoPlay: config.autoplay
        });
    });
};

Arrow.prototype.createPreviewStream = function(options, callback) {
    $.ajax({
        type: "POST",
        contentType: "application/json",
        url: this.createPreviewStreamUrl,
        data: JSON.stringify({
            setup: 'arrow',
            url: options.url,
            region: options.continentCode,
            camera_type: options.cameraType
        }),
        success: callback
    });
};

Arrow.prototype.scanNetwork = function() {
    $.ajax({
        type: "POST",
        data: {
            command: 'scan_network',
        }
    });
};

Arrow.prototype.pollDeviceStatus = function() {
    $.ajax({
        type: "POST",
        data: {
            command: 'poll_device_status',
        },
        success: function(data) {
            if (data.next) {
                window.location.replace(data.next);
            }
        }
    });
};

Arrow.prototype.setCredentials = function(key, url, brand, cameraType, onSuccess) {
    $.ajax({
        type: "POST",
        data: {
            command: 'set_credentials',
            key: key,
            url: url,
            brand: brand,
            camera_type: cameraType
        },
        success: onSuccess
    });
};

Arrow.prototype.toString = function() {
    return 'Arrow';
};

export default Arrow;
